module.exports = __webpack_public_path__ + "img/aura.5522756e.png";